import { C, P0, S, abs, fillAt, lerp, max, quad } from '../../geometry';

export const cat = {
  name: 'Cat',
  colors: ['#161616', '#E5484D'],
  draw(m, t) {
    let eL = [30, 19],
      eR = [70, 19],
      wh = 0,
      pose = P0();
    const tw = Math.pow(max(0, S(t * 0.9)), 10) * 4;
    eR = [70 + tw * 0.4, 19 + tw];
    let tail = [
      [76, 76],
      [87, 74],
      [91, 63 + 2 * S(t * 2)],
      [86 + 3 * S(t * 2), 55],
    ];
    if (m === 'happy') {
      eL = [28, 14];
      eR = [72, 14];
      const w = 6 * S(t * 10);
      tail = [
        [76, 76],
        [86, 70],
        [89, 58],
        [86 + w, 47],
      ];
      wh = -3;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the tail tip keeps curling round; one ear turns back.
    if (m === 'thinking') {
      const c = t * 3;
      eR = [74 + 2 * S(t * 1.3), 25];
      tail = [
        [76, 76],
        [88, 72],
        [92, 61],
        [87 + 4 * C(c), 54 + 4 * S(c)],
        [83 + 5 * C(c + 1.4), 58 + 5 * S(c + 1.4)],
      ];
      pose.rot = 3 + 1.5 * S(t * 1.3);
    }
    if (m === 'talking') {
      wh = 3 * S(t * 12);
      eL = [30, 19 + S(t * 9)];
      eR = [70, 19 - S(t * 9)];
    }
    if (m === 'surprised') {
      eL = [28, 9];
      eR = [72, 9];
      tail = [
        [76, 76],
        [84, 66],
        [86 + S(t * 26), 50],
        [86 + S(t * 26), 36],
      ];
      wh = -5;
      pose.ty = -2;
    }
    if (m === 'paused') {
      eL = [21, 28];
      eR = [79, 28];
      tail = [
        [76, 76],
        [66, 84 + S(t * 0.9)],
        [50, 86],
        [36, 82],
      ];
      pose.ty = 2;
    }
    const tipL = (p, a, b) => [
      [lerp(a[0], p[0], 0.82), lerp(a[1], p[1], 0.82)],
      p,
      [lerp(b[0], p[0], 0.82), lerp(b[1], p[1], 0.82)],
    ];
    const head = [
      ...quad([24, 80], [20, 56], [28, 37], 6),
      ...tipL(eL, [28, 37], [42, 30]),
      ...quad([42, 30], [50, 27], [58, 30], 4),
      ...tipL(eR, [58, 30], [72, 37]),
      ...quad([72, 37], [80, 56], [76, 80], 6),
    ];
    return {
      strokes: [
        { c: 'a', pts: head, n: 44 },
        {
          c: 'a',
          pts: [
            [21, 62],
            [8, 60 + wh],
          ],
        },
        {
          c: 'a',
          pts: [
            [79, 62],
            [92, 60 + wh],
          ],
        },
        { c: 'b', pts: tail },
      ],
      eyes: { x: 50, y: 56 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
